import { render } from "./AboutTwoPage.vue?vue&type=template&id=7c64c3a6"
import script from "./AboutTwoPage.vue?vue&type=script&lang=js"
export * from "./AboutTwoPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__